// Splits `total` by each item's percentage, rounded to 2 decimals.
// The rounding difference goes to the item with the highest percentage so
// the allocations always add up to exactly `total`.
//
// allocateByPercentage(600000, [{ id: "a", percentage: 60 }, { id: "b", percentage: 40 }])
// -> { a: 360000, b: 240000 }
export const allocateByPercentage = (total, items) => {
  const result = {};
  if (!items.length) return result;

  const totalCents = Math.round((Number(total) || 0) * 100);
  let allocatedCents = 0;

  items.forEach((item) => {
    const cents = Math.floor(
      (totalCents * (Number(item.percentage) || 0)) / 100,
    );
    result[item.id] = cents;
    allocatedCents += cents;
  });

  const highest = items.reduce((max, item) =>
    Number(item.percentage) > Number(max.percentage) ? item : max,
  );
  result[highest.id] += totalCents - allocatedCents;

  Object.keys(result).forEach((id) => {
    result[id] = result[id] / 100;
  });

  return result;
};
